import TabItem = require("./tab/TabItem");
import GoogleAnalyticsService = require("../service/GoogleAnalyticsService");

class AuraView extends TabItem {

    constructor(template: JQuery) {
        super(template);
    }


    init(): void {
        this.createFilterBtn();
    }

    private currentFilter: string;
    private $colorpicker: JQuery;
    private $filterBtn: JQuery;
    private $block: JQuery;
    private filterTrackingCode: any[];

    private createFilterBtn(): void {

        this.filterTrackingCode = [
            {category: "icons", action: "clicked", label: "matrix2080ti-experience-overview-aura-static"},
            {category: "icons", action: "clicked", label: "matrix2080ti-experience-overview-aura-breathing"},
            {category: "icons", action: "clicked", label: "matrix2080ti-experience-overview-aura-strobing"},
            {category: "icons", action: "clicked", label: "matrix2080ti-experience-overview-aura-color-cycle"},
            {category: "icons", action: "clicked", label: "matrix2080ti-experience-overview-aura-music-effect"}
        ];

        this.currentFilter = "cycleFilter";
        this.$colorpicker = this.$template.find(".colorPicker");
        this.$block = this.$template.find(".colorBlock");

        let btnTotal: number = this.$template.find(".filterBtn").length;
        for (let i: number = 0; i < btnTotal; i++) {
            this.$filterBtn = this.$template.find(".filterBtn:eq(" + i + ")");
            this.$filterBtn.on("click tap", {id: i}, (event: JQueryEventObject) => {
                event.preventDefault();
                // @ts-ignore
                let id: number = event.data["id"];
                // @ts-ignore
                this.changeBtn(event.data["id"]);
                this.changeFilter($(event.currentTarget).data("filter"));

                GoogleAnalyticsService.instance().sendTracking(
                    'event',
                    this.filterTrackingCode[id]["category"],
                    this.filterTrackingCode[id]["action"],
                    this.filterTrackingCode[id]["label"]
                )
            });
        }

        this.changeFilter("cycle");
    }
    private changeBtn(id: number): void {

        let btnTotal: number = this.$template.find(".filterBtn").length;
        for (let i: number = 0; i < btnTotal; i++) {
            this.$filterBtn = this.$template.find(".filterBtn:eq(" + i + ")");
            if (i == id) {
                this.$filterBtn.addClass("active");
            } else {
                this.$filterBtn.removeClass("active");
            }
        }

        if (id == 3) {
            this.$colorpicker.removeClass("active");
        } else {
            this.$colorpicker.addClass("active");
        }
    }

    private changeFilter(filter: string): void {

        this.$block.removeClass(this.currentFilter);
        this.currentFilter = filter + "Filter";
        this.$block.addClass(this.currentFilter);
    }
}

export = AuraView;